import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import parliamentarianUsers from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import useStakeholderBioTabCounts from 'components/Dashboard/StakeHolders/StakeholderPage/useStakeholderBioTabCounts';
import ProfileImage from 'components/Dashboard/StakeHolders/StakeholderPage/ui/ProfileImage';
import BioElementsTabs from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioElementsTabs';
import AboutTab from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioSections/AboutTab';
import Notes from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioSections/Notes';
import Groups from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioSections/Groups';
import Interactions from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioSections/Interactions';

const BioElements = React.forwardRef((props, ref) => {
  const {
    StakeholderInformation,
    activePlan,
    setActiveTab,
    activeTab,
    setShowContactsPopup,
    setShowStakeholderCrmPopup,
    bioElementsScrollBarPosition,
    updateChampionStatus,
    bioSectionContainer,
  } = props;

  const [selectedVisibility, setSelectedVisibility] = useState('user');
  const { isAuthenticated } = useAuth0();
  const isMobile = useIsMobile();
  const { code, enableCrm } = activePlan;

  const { notesFunctions, notesCount, interactionsCount, groupsCount, countsReady, refetchInteractionsCount } =
    useStakeholderBioTabCounts({
      StakeholderInformation,
      enabled: isAuthenticated && enableCrm && !parliamentarianUsers(code),
    });

  const BioElementTabsProperties = {
    activeTab,
    setActiveTab,
    setShowContactsPopup,
    setShowStakeholderCrmPopup,
    bioSectionContainer,
    StakeholderInformation,
    notesCount,
    interactionsCount,
    groupsCount,
    countsReady,
  };

  return (
    <div ref={ref}>
      <div className={`box-top-rounded biography-container`}>
        {/* On mobile, MobileUI renders the profile image above its own section switcher */}
        {isMobile ? (
          <BioElementsTabs {...BioElementTabsProperties} />
        ) : (
          <div
            className={`sticky-item box-top-rounded border-bottom-none ${
              bioElementsScrollBarPosition > 0 ? 'activity-title-scrolled' : ''
            }`}
          >
            <ProfileImage StakeholderInformation={StakeholderInformation} />
            <BioElementsTabs {...BioElementTabsProperties} />
          </div>
        )}

        <div className='biography-secondary-container border-right border-left'>
          {activeTab === 'Profile' && (
            <AboutTab
              StakeholderInformation={StakeholderInformation}
              activePlan={activePlan}
              setShowContactsPopup={setShowContactsPopup}
              updateChampionStatus={updateChampionStatus}
              bioElementsScrollBarPosition={bioElementsScrollBarPosition}
            />
          )}
          {activeTab === 'Notes' && (
            <Notes
              StakeholderInformation={StakeholderInformation}
              activePlan={activePlan}
              selectedVisibility={selectedVisibility}
              setSelectedVisibility={setSelectedVisibility}
              notesFunctions={notesFunctions}
            />
          )}
          {activeTab === 'Interactions' && (
            <Interactions
              StakeholderInformation={StakeholderInformation}
              activePlan={activePlan}
              onInteractionsChanged={refetchInteractionsCount}
            />
          )}
          {activeTab === 'Groups' && <Groups StakeholderInformation={StakeholderInformation} activePlan={activePlan} />}
        </div>
      </div>
    </div>
  );
});

export default BioElements;
